module.exports = __webpack_public_path__ + "img/spamhaus-logo.2ae0f735.png";